export class TypeHandicap {
    readonly id: number;
    name: string;
}

